module.exports = __webpack_public_path__ + "static/media/crop-page-2.a771039c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/assets/crop-page-2.jpg
// module id = 1415
// module chunks = 0